export const SFG_COLOR = "#1d4ed8";
export const FG_COLOR = "#0f766e";

// Tonnes with 2 decimals; exact kg on hover.
export const T = ({ kg, className = "", testId }) => (
  <span data-testid={testId} title={`${Number(kg || 0).toFixed(1)} kg`} className={`font-mono-data cursor-help ${className}`}>
    {(Number(kg || 0) / 1000).toFixed(2)} t
  </span>
);

export const Section = ({ icon: Icon, eyebrow, title, right, children, testId, className = "" }) => (
  <section data-testid={testId} className={`bg-white border border-slate-200 rounded-sm p-5 ${className}`}>
    <div className="flex items-start justify-between gap-3 mb-4">
      <div className="flex items-center gap-3">
        <div className="h-8 w-8 rounded-sm bg-slate-900 text-white flex items-center justify-center"><Icon className="h-4 w-4" /></div>
        <div>
          <p className="text-[10px] tracking-[0.25em] uppercase text-slate-500 font-semibold">{eyebrow}</p>
          <h3 className="font-heading text-base md:text-lg font-black tracking-tight text-slate-900 leading-tight">{title}</h3>
        </div>
      </div>
      {right}
    </div>
    {children}
  </section>
);

export const Empty = ({ text, testId }) => (
  <p data-testid={testId} className="text-sm text-slate-400 italic py-6 text-center">{text}</p>
);

export const BarList = ({ rows, labelKey, color, testId }) => {
  const max = Math.max(1, ...rows.map((r) => r.kg));
  return (
    <ul data-testid={testId} className="space-y-2">
      {rows.map((r) => (
        <li key={r[labelKey]} className="text-sm">
          <div className="flex justify-between gap-2">
            <span className="truncate text-slate-700 font-medium">{r[labelKey]}</span>
            <T kg={r.kg} className="text-slate-900 font-semibold" />
          </div>
          <div className="h-1.5 bg-slate-100 rounded-sm mt-1 overflow-hidden">
            <div className="h-full rounded-sm transition-[width] duration-700" style={{ width: `${(r.kg / max) * 100}%`, background: color }} />
          </div>
        </li>
      ))}
    </ul>
  );
};

export const TopCustomers = ({ rows, testId }) => (
  <ol data-testid={testId} className="space-y-1.5">
    {rows.map((r, i) => (
      <li key={r.customer} className="flex items-center gap-2 text-sm">
        <span className={`h-5 w-5 shrink-0 rounded-sm text-[10px] font-bold flex items-center justify-center ${i === 0 ? "bg-amber-400 text-slate-900" : "bg-slate-100 text-slate-600"}`}>{i + 1}</span>
        <span className="truncate flex-1 text-slate-700">{r.customer}</span>
        <T kg={r.kg} className="text-slate-900 font-semibold" />
      </li>
    ))}
  </ol>
);
